import React from 'react'
import Layout from '../Components/Layout'
import Try from "../pages/Try"
import NavBar from '../Components/NavBar'
import ContactForm from '../Components/ContactForm'
import { CSSTransition } from 'react-transition-group';

import '../transition.css'

const Contact = () => {

  const [Mounted, setMounted] = React.useState(false);

  React.useEffect(() => {
    setMounted(true);
  }, []);

  return (
    <Layout title=" Sarvadnya || Contact">
        <div className=' relative  '>
        <Try/>
        <NavBar />
        <h1 className=' absolute top-32 left-20 text-white font-bold  text-3xl font-serif  hover: underline-offset-4 cursor-pointer text-center transform transition-transform duration-100 hover:scale-125 '>CONTACT ME</h1>

        <CSSTransition in={Mounted} timeout={1500} classNames='custom'>
        <ContactForm />
        </CSSTransition> 
        </div>
    </Layout>
  )
}

export default Contact